// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__1RsrZ","icon":"Skill_icon__U-I0N","title":"Skill_title__f+huw","description":"Skill_description__iMMaX"};